module.exports = __webpack_public_path__ + "img/Megaphon_logo_v.d9195b8b.png";